export const allSupportedFonts = [
  'Forum',
  'American Typewriter',
  'Andale Mono',
  'Arial',
  'Arial Black',
  'Bradley Hand',
  'Brush Script MT',
  'Comic Sans MS',
  'Courier New',
  'Didot',
  'Garamond',
  'Georgia',
  'Helvetica',
  'Impact',
  'Luminari',
  'Monaco',
  'Tahoma',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
  'IBM Plex Serif',
  'Lato',
  'OpenDyslexic',
  'Yellowtail',
]
